import { NgIf } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { StyleDirective } from '@panaya/ui/styles-to-code';
import { FeatherModule } from 'angular-feather';
import { allIcons } from 'angular-feather/icons';

import { PIconImageComponent } from './icon-image/p-icon-image.component';
import { PIconComponent } from './icon/p-icon.component';
import { injectPIconConfig, PIconConfig, providePIconConfig } from './p-icon-config.provider';
import { svgIconNames as builtInSvgIcons } from './svg-icons';

@NgModule({
    imports: [NgIf, FeatherModule.pick(allIcons), MatIconModule, StyleDirective],
    declarations: [PIconComponent, PIconImageComponent],
    exports: [PIconComponent, PIconImageComponent, FeatherModule]
})
export class PIconModule {
    public static config(config: Partial<PIconConfig>): ModuleWithProviders<PIconModule> {
        return {
            ngModule: PIconModule,
            providers: [providePIconConfig(config)]
        };
    }

    private readonly config = injectPIconConfig();

    constructor(private readonly domSanitizer: DomSanitizer, private readonly matIconRegistry: MatIconRegistry) {
        // Remove trailing slash from the defined assets folder
        const assetsFolder = this.config.svgIconsOutputFolder.replace(/[\\/]$/, '');

        this.registerAllSvgIcons(assetsFolder);
    }

    private registerAllSvgIcons(assetsFolder: string): void {
        new Set([...builtInSvgIcons, ...this.config.customSvgIconNames]).forEach((icon) => this.registerSvgInMaterial(assetsFolder, icon));
    }

    private registerSvgInMaterial(assetsFolder: string, icon: string): void {
        this.matIconRegistry.addSvgIcon(icon, this.domSanitizer.bypassSecurityTrustResourceUrl(`${assetsFolder}/${icon}.svg`));
    }
}
